import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'reactstrap';

const SearchComponentWithoutDropDown = ({
  name,
  setValues,
  isnumeric,
  value = '',
  onSearch,
  placeholder = 'Search...'
}) => {
  const [searchValue, setSearchValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleChange = (e) => {
    let val = e.target.value;

    if (isnumeric) {
      // Remove all non-digit characters
      val = val.replace(/\D/g, '');
    }

    setSearchValue(val);
    setValues(prev => ({ ...prev, [name]: val }));
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (typeof onSearch === 'function') {
        onSearch(searchValue); // Call API on Enter
      }
    }
  };

  return (
    <div className="app-search">
      <div className="position-relative">
        <Input
          type="text"
          className="form-control form-control-sm"
          placeholder={placeholder}
          value={searchValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          innerRef={inputRef}
          style={{ fontSize: '13px' }} // 👈 Optional font-size styling
        />
        <span className="mdi mdi-magnify search-widget-icon" />
      </div>
    </div>
  );
};

export default SearchComponentWithoutDropDown;
